import axiosInstance from "../../utils/axiosInstance";
import { FORM_SUBMIT_URL, BASE_URL } from "../../../constants";
import { toast } from "react-toastify";

export const validateAndSubmitRevidirani = async (
  values,
  selectedRecord,
  cleanup,
  update,
  transitionToUpdate,
  setIdPredPosEvid,
  setShowPotpisivanjeConfirmationModal,
  role,
  fetchEvidencijeTableData
) => {
  const valuesCopy = { ...values };

  delete valuesCopy.dokumenti;

  const URL = FORM_SUBMIT_URL[selectedRecord];

  const formData = new FormData();

  formData.append("revidiraniSJI", JSON.stringify(valuesCopy));

  if (values.dokumenti.length > 0) {
    values.dokumenti.map((attachment) =>
      formData.append("dokumenti", attachment.originFileObj)
    );
  }

  if (update) {
    const { idPredPosEvid, obrisaniDokumenti } = valuesCopy;

    formData.append("idPredPosEvid", idPredPosEvid);
    formData.append("obrisaniDokumenti", obrisaniDokumenti);
  }

  try {
    //nalazim treće od nazad mjesto u stringu i provjeravam je li zarez za polje prihodi od revizije, koliko ima zareza u polju, te je li zarez prvi znak
    const zarez = values.prihodiOdRevizije.slice(-3,-2);
    let isNotZarez = (zarez == "," ? false : true);
    const numberZarez = (values.prihodiOdRevizije.split(",").length - 1);
    const prviZnak = values.prihodiOdRevizije.substring(0,1);
    let firstIsZarez = (prviZnak == "," ? true : false);
    //za polje prihodi koje zahtjeva zakonodavstvo
    const zarezPrihodiKojeZahtjevaZakonodavstvo = values.prihodiKojeZahtjevaZakonodavstvo.slice(-3,-2);
    let isNotZarezPrihodiKojeZahtjevaZakonodavstvo = (zarezPrihodiKojeZahtjevaZakonodavstvo == "," ? false : true);
    const numberZarezPrihodiKojeZahtjevaZakonodavstvo = (values.prihodiKojeZahtjevaZakonodavstvo.split(",").length - 1);
    const prviZnakPrihodiKojeZahtjevaZakonodavstvo = values.prihodiKojeZahtjevaZakonodavstvo.substring(0,1);
    let firstIsZarezPrihodiKojeZahtjevaZakonodavstvo = (prviZnakPrihodiKojeZahtjevaZakonodavstvo == "," ? true : false);
    //za polje prihodi koje ne zahtjeva zakonodavstvo
    const zarezPrihodiKojeNeZahtjevaZakonodavstvo = values.prihodiKojeNeZahtjevaZakonodavstvo.slice(-3,-2);
    let isNotZarezPrihodiKojeNeZahtjevaZakonodavstvo = (zarezPrihodiKojeNeZahtjevaZakonodavstvo == "," ? false : true);
    const numberZarezPrihodiKojeNeZahtjevaZakonodavstvo = (values.prihodiKojeNeZahtjevaZakonodavstvo.split(",").length - 1);
    const prviZnakPrihodiKojeNeZahtjevaZakonodavstvo = values.prihodiKojeNeZahtjevaZakonodavstvo.substring(0,1);
    let firstIsZarezPrihodiKojeNeZahtjevaZakonodavstvo = (prviZnakPrihodiKojeNeZahtjevaZakonodavstvo == "," ? true : false);
    
    //ako neko od polja za prihode ne sadrži zarez ili se on ne nalazi na trećem od nazad mjestu 
    if((values.prihodiOdRevizije.length>0 && (isNotZarez==true || numberZarez !=1  || firstIsZarez==true)) ||
    (values.prihodiKojeZahtjevaZakonodavstvo.length>0 && (isNotZarezPrihodiKojeZahtjevaZakonodavstvo==true || numberZarezPrihodiKojeZahtjevaZakonodavstvo !=1 || firstIsZarezPrihodiKojeZahtjevaZakonodavstvo==true)) ||
    (values.prihodiKojeNeZahtjevaZakonodavstvo.length>0 && (isNotZarezPrihodiKojeNeZahtjevaZakonodavstvo==true || numberZarezPrihodiKojeNeZahtjevaZakonodavstvo !=1 || firstIsZarezPrihodiKojeNeZahtjevaZakonodavstvo==true))) {
      toast.error("Format prihoda neispravan!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }else {
    if (!update) {
      const { data } = await axiosInstance.post(`${BASE_URL}${URL}`, formData);
      const { idPredPosEvid } = data;
      if (role === "ROLE_KORISNIK") {
        setIdPredPosEvid(idPredPosEvid);
        setShowPotpisivanjeConfirmationModal(true);
      }
    } else {
      await axiosInstance.patch(`${BASE_URL}${URL}`, formData);
    }
    toast.success("Posebna evidencija spremljena", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    fetchEvidencijeTableData();
    cleanup();
  }
  } catch (e) {
    if (e.response.data.statusCode == 418) {
      transitionToUpdate();
    }
    if (e.response.data.msg) {
      toast.info(e.response.data.msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else {
      toast.info("Nešto je pošlo po krivu. Molimo pokušajte ponovno!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }
};
